"use strict";

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");
var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");
_Object$defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
require("@webex/internal-plugin-conversation");
require("@webex/internal-plugin-mercury");
var _webexCore = require("@webex/webex-core");
var _rooms = _interopRequireDefault(require("./rooms"));
/*!
 * Copyright (c) 2015-2020 Cisco Systems, Inc. See LICENSE file.
 */

(0, _webexCore.registerPlugin)('rooms', _rooms.default);
var _default = _rooms.default;
exports.default = _default;
//# sourceMappingURL=index.js.map
